import { CreditCard, Download, RefreshCw, User } from "lucide-react";
import { useState } from "react";
import { downloadBase64PDF } from "@/utils/constant/downloadBase64PDF";
import DownloadStatementService from "@/services/FinEaseUser/APIs/DownloadStatementService";

const ActionButtons = () => {
  const [active, setActive] = useState("contribution");

  const handleDownload = async () => {
    try {
      const res = await new DownloadStatementService().getDownloadStatement();

      if (res.success && res.sotData.pdfbuffer) {
        downloadBase64PDF(res.sotData.pdfbuffer, "Statement.pdf");
      } else {
        console.error("PDF data missing");
      }
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  const isActive = (key: string) => active === key;

  const getButtonClasses = (key: string) =>
    isActive(key)
      ? `
        bg-primary text-primary-foreground shadow-sm hover:shadow-md
        hover:bg-primary/90
      `
      : `
        border-2 border-border bg-transparent text-foreground
        hover:bg-muted/50 hover:border-border/80
      `;

  const getIconClasses = (key: string) =>
    isActive(key) ? "text-primary-foreground" : "text-primary";

  const getTitleClasses = (key: string) =>
    isActive(key) ? "text-primary-foreground" : "text-secondary";

  const getSubTextClasses = (key: string) =>
    isActive(key) ? "text-primary-foreground/80" : "text-muted-foreground";

  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
      {/* Make Contribution */}
      <button
        onClick={() => setActive("contribution")}
        className={`inline-flex h-auto flex-col items-center justify-center gap-2 whitespace-nowrap rounded-xl px-5 py-5 text-sm font-semibold transition-all duration-200 ${getButtonClasses("contribution")} `}
      >
        <CreditCard className={`h-6 w-6 ${getIconClasses("contribution")}`} />
        <span className={`font-semibold ${getTitleClasses("contribution")}`}>
          Make Contribution
        </span>
        <span className={`text-xs ${getSubTextClasses("contribution")}`}>
          Add to your corpus
        </span>
      </button>

      {/* Download Statement */}
      <button
        onClick={() => {
          setActive("download");
          handleDownload();
        }}
        className={`inline-flex h-auto flex-col items-center justify-center gap-2 whitespace-nowrap rounded-xl px-5 py-5 text-sm font-semibold transition-all duration-200 ${getButtonClasses("download")} `}
      >
        <Download className={`h-6 w-6 ${getIconClasses("download")}`} />
        <span className={`font-semibold ${getTitleClasses("download")}`}>
          Download Statement
        </span>
        <span className={`text-xs ${getSubTextClasses("download")}`}>
          PDF / Excel format
        </span>
      </button>

      {/* Switch Fund Manager */}
      <button
        onClick={() => setActive("switch")}
        className={`inline-flex h-auto flex-col items-center justify-center gap-2 whitespace-nowrap rounded-xl px-5 py-5 text-sm font-semibold transition-all duration-200 ${getButtonClasses("switch")} `}
      >
        <RefreshCw className={`h-6 w-6 ${getIconClasses("switch")}`} />
        <span className={`font-semibold ${getTitleClasses("switch")}`}>
          Switch Fund Manager
        </span>
        <span className={`text-xs ${getSubTextClasses("switch")}`}>
          Change your PFM
        </span>
      </button>

      {/* Update Nominee */}
      <button
        onClick={() => setActive("nominee")}
        className={`inline-flex h-auto flex-col items-center justify-center gap-2 whitespace-nowrap rounded-xl px-5 py-5 text-sm font-semibold transition-all duration-200 ${getButtonClasses("nominee")} `}
      >
        <User className={`h-6 w-6 ${getIconClasses("nominee")}`} />
        <span className={`font-semibold ${getTitleClasses("nominee")}`}>
          Update Nominee
        </span>
        <span className={`text-xs ${getSubTextClasses("nominee")}`}>
          Add or modify
        </span>
      </button>
    </div>
  );
};

export default ActionButtons;
